import { interpretReceiverAddressError } from "./interpretators";
import { validators } from "./validators";

export const validateReceiver = (receiver) => {
    let errors = []
    if (!receiver) {
        return ['Receiver is required'];
    }

    if(!receiver["receiver-name"]) {
        errors.push('errors.receiver_name.required');
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(receiver["receiver-name"]) ||
                validators.HasOnlyLettersAndSpaces(receiver["receiver-name"])) {
        errors.push("errors.receiver_name.only_english_letters");
    } else if (validators.ValidateLength(receiver["receiver-name"], 2)) {
        errors.push("errors.receiver_name.min_2");
    }

    if(validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(receiver["receiver-company"])) {
        errors.push("errors.receiver_company.only_english_letters")
    }

    if (!receiver["receiver-email"]) {
        errors.push("errors.receiver_email.required");
    } else if (validators.ValidateEmail(receiver["receiver-email"])) {
        errors.push("errors.receiver_email.invalid_format");
    }

    if (!receiver["receiver-phone-number"]) {
        errors.push("errors.receiver_phone.required");
    } else if (validators.ValidatePhone(receiver["receiver-phone-number"])) {
        errors.push("errors.receiver_phone.invalid_format");
    }    

    if (!receiver["receiver-address"]) {
        errors.push("errors.receiver_address.required");
    } else if (validators.ValidateReceiverAddress(receiver["receiver-address"])) {
        errors.push(
            interpretReceiverAddressError(
                validators.ValidateReceiverAddress(receiver["receiver-address"])
            )
        );
    }

    if (!receiver["receiver-postal-index"]) {
        errors.push("errors.receiver_postal_index.required");
    }

    return errors
}